import React from 'react';
import { Award, Users } from 'lucide-react';

const CoachingBanner: React.FC = () => {
  return (
    <div className="bg-gradient-to-r from-snooker-green via-primary-black to-snooker-green border-b-2 border-primary-gold">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-4 text-center md:text-left">
            <div className="hidden md:flex items-center justify-center w-16 h-16 bg-primary-gold/10 rounded-full border-2 border-primary-gold flex-shrink-0">
              <Award className="w-8 h-8 text-primary-gold" />
            </div>
            <div>
              <h3 className="text-xl md:text-2xl font-bold text-primary-gold font-display mb-1">
                Professional Coaching Available
              </h3>
              <p className="text-gray-300 text-sm md:text-base">
                <span className="font-semibold text-white">Billy Snaddon</span> - Cuesports Ambassador & Coach
                <span className="hidden sm:inline"> | Formerly ranked 24th in the world</span>
              </p>
            </div>
          </div>
          <a
            href="/coaching"
            className="flex items-center gap-2 bg-primary-gold text-primary-black px-6 py-3 rounded-full font-semibold hover:bg-primary-black hover:text-primary-gold hover:border-2 hover:border-primary-gold transition-all whitespace-nowrap"
            aria-label="Learn more about coaching with Billy Snaddon"
          >
            <Users className="w-5 h-5" />
            <span>Learn More</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default CoachingBanner;
